import template from './communication-tool-filter.template.html';
import controller from './communication-tool-filter.controller';
import './communication-tool-filter.scss';

export default {
  template,
  controller,
  bindings: {
    communicationToolFilterFilters: '<',
    communicationToolFilterPreselected: '<?',
    onChangeCommunicationToolFilter: '&?',
  },
};



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool-filter/communication-tool-filter.component.js